import { render, staticRenderFns } from "./ClinicianEditMeasureResponses.vue?vue&type=template&id=27f1694a"
import script from "./ClinicianEditMeasureResponses.vue?vue&type=script&lang=js"
export * from "./ClinicianEditMeasureResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports